import styled from '@emotion/styled';
import { SmallText } from 'ds/components/typography';

export const FeedbackPopupContentWrapper = styled.div`
  position: relative;
  display: flex;
`;


// feedback form

export const FeedbackFormWrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const CommentTextWrapper = styled.div`
  position: relative;
  .styled-error-msg {
    position: absolute;
    top: 100%;
  }
  ${({ theme }) => `
    display: flex;
    margin-top: ${theme.spacing(2)};

    & > div {
      width: 100%;
    }
  `}
`;

export const EmailWrapper = styled.div`
  ${({ theme }) => `
    display: flex;
    flex-direction: column;
    margin-top: ${theme.spacing(5)};
  `}
`;

export const Description = styled(SmallText)`
  ${({ theme }) => `
    color: ${theme.colors.neutrals.grey2};
    margin-bottom: ${theme.spacing(2)};
  `}
`;
